import { useEffect } from "react";
import { ArrowRight, CheckCircle2, Clock3, ShieldCheck } from "lucide-react";
import { Link } from "wouter";
import { SiteLayout } from "@/components/SiteChrome";
import { trpc } from "@/lib/trpc";

export default function BlueprintSuccess() {
  const sessionId = new URLSearchParams(window.location.search).get("session_id") ?? "";
  const confirmation = trpc.blueprints.confirmCheckout.useQuery({ sessionId }, { enabled: Boolean(sessionId), retry: 2 });

  useEffect(() => { document.title = "Blueprint payment confirmation | Altitude Fitness Management Group"; }, []);

  const content = !sessionId ? {
    icon: <ShieldCheck size={32} />,
    eyebrow: "Checkout confirmation",
    title: "We’re confirming your payment.",
    copy: "Your transaction may still be processing. Please check your email for a receipt, or contact Altitude if you need help.",
  } : confirmation.isLoading ? {
    icon: <Clock3 size={32} />,
    eyebrow: "Confirming payment",
    title: "One moment while we confirm your Blueprint.",
    copy: "We’re securely checking the payment status with Stripe.",
  } : confirmation.data?.paid ? {
    icon: <CheckCircle2 size={32} />,
    eyebrow: "Payment confirmed",
    title: "Your Blueprint is now in motion.",
    copy: `We received your payment${confirmation.data.reference ? ` (reference ${confirmation.data.reference})` : ""}. An Altitude team member will contact you within one business day to begin your intake and delivery plan.`,
  } : {
    icon: <Clock3 size={32} />,
    eyebrow: "Payment still processing",
    title: "Your checkout is not marked complete yet.",
    copy: "If you completed payment, Stripe will keep processing it securely. Please check your inbox for a receipt or contact Altitude for help.",
  };

  return <SiteLayout><section className="checkout-status"><div className="checkout-status__card"><span className="checkout-status__icon">{content.icon}</span><p className="eyebrow">{content.eyebrow}</p><h1>{content.title}</h1><p>{content.copy}</p><div><Link href="/contact" className="button button--coral">Contact Altitude <ArrowRight size={16} /></Link><Link href="/" className="button button--navy">Return home</Link></div></div></section></SiteLayout>;
}
